var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Nav-Tray",
    transform: "translate(-665.000000, -27.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-104.000000, -23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Primary-Nav",
    transform: "translate(356.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "More",
    transform: "translate(408.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.28571429,0 C5.57589286,0 5,0.80625 5,1.8 C5,2.79375 5.57589286,3.6 6.28571429,3.6 L21.7142857,3.6 C22.4241071,3.6 23,2.79375 23,1.8 C23,0.80625 22.4241071,0 21.7142857,0 M6.28571429,7.2 C5.57589286,7.2 5,8.00625 5,9 C5,9.99375 5.57589286,10.8 6.28571429,10.8 L21.7142857,10.8 C22.4241071,10.8 23,9.99375 23,9 C23,8.00625 22.4241071,7.2 21.7142857,7.2 L6.28571429,7.2 Z M6.28571429,14.4 C5.57589286,14.4 5,15.20625 5,16.2 C5,17.19375 5.57589286,18 6.28571429,18 L21.7142857,18 C22.4241071,18 23,17.19375 23,16.2 C23,15.20625 22.4241071,14.4 21.7142857,14.4 L6.28571429,14.4 Z",
    id: "more"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.ef74db05538a1c3012fc128160635a65.svg";
export { ForwardRef as ReactComponent };